import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pl-3 pt-4" }

import { SENSOR_ALERT_BATTERY_LEVEL } from '@/services/consts/operation_office';
import SelectBox from '@/components/Common/selectBox.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

type keyValue = {
  key: string | number,
  value: string | number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SensorNotificationBatteryAlert',
  props: {
    modelValue: {},
    windowInnerWidth: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "text-form pl-4 pr-3 mt-2 mb-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: props.windowInnerWidth > 800 ? 2 : 3
      }, null, 8, ["cols"]),
      _createVNode(_component_v_col, {
        cols: props.windowInnerWidth > 800 ? 2 : 3
      }, {
        default: _withCtx(() => [
          _createElementVNode("h6", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.tdsensor.batteryAlert')), 1)
        ]),
        _: 1
      }, 8, ["cols"]),
      _createVNode(_component_v_col, {
        cols: props.windowInnerWidth > 800 ? 2 : 3
      }, {
        default: _withCtx(() => [
          _createVNode(SelectBox, {
            modelValue: modelValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
            items: _unref(SENSOR_ALERT_BATTERY_LEVEL),
            clearable: false
          }, null, 8, ["modelValue", "items"])
        ]),
        _: 1
      }, 8, ["cols"]),
      _createVNode(_component_v_col, {
        cols: props.windowInnerWidth > 800 ? 2 : 3
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.tdsensor.batteryAlertLabel')), 1)
        ]),
        _: 1
      }, 8, ["cols"])
    ]),
    _: 1
  }))
}
}

})